import cx from 'classnames';
import store from '~/javascripts/store.js';
import { Component } from 'react';
import { observer } from 'mobx-react';

const DonateFormIhoDesign = observer(
  class DonateFormIhoDesign extends Component {
    chooseDesign(design) {
      store.iho.design = design;

      if (this.props.onDesignClick) this.props.onDesignClick();
    }

    render() {
      return (
        <div className='choose-design'>
          {store.iho.designs.map((design) => (
            <a
              className={cx('design', {
                active: store.iho.design.slug === design.slug,
              })}
              key={design.slug}
              onClick={() => this.chooseDesign(design)}
            >
              <img src={design.printImageUrl} />
            </a>
          ))}
        </div>
      );
    }
  }
);

export default DonateFormIhoDesign;
